class ButtonManager {
  constructor({ iconManager, styleManager }) {
    this._iconManager = iconManager;
    this._styleManager = styleManager;
  }

  // getSrc(props) {
  //   const icon = this._iconManager.getSrc(props);

  //   return icon;
  // }

  getReactIcon(props) {
    const icon = this._iconManager.getReactIcon(props);

    return icon;
  }

  getStyle(props) {
    const style = this._styleManager.getStyle(props);

    return style;
  }

  shouldShowIcon({ disabled, clicked }) {
    const iconManager = this._iconManager;
    const { icon, iconHover, iconLoading, iconDisabled } = iconManager.getIcons();

    return !!icon || !!iconHover || (iconLoading && clicked) || (disabled && iconDisabled);
  }

  shouldShowTag({ loadingOnClick, clicked }) {
    return !(loadingOnClick && clicked);
  }
}

export default ButtonManager;
